import React, { forwardRef, useEffect, useState } from "react";
import Icon from "./icon";
import classNames from "classnames";
import { Link } from "./link";

const ButtonWTB = forwardRef(
  ({ reevooTrack, sku, assetId, label, className, iconName, color, storeLink }, ref) => {
    const [campaign, setCampaign] = useState();
    const [source, setSource] = useState();
    const [medium, setMedium] = useState();
    const [content, setContent] = useState();
    const [term, setTerm] = useState();

    useEffect(() => {
      if (sessionStorage.getItem("utm_campaign")) {
        setCampaign(sessionStorage.getItem("utm_campaign"));
      }
      if (sessionStorage.getItem("utm_source")) {
        setSource(sessionStorage.getItem("utm_source"));
      }
      if (sessionStorage.getItem("utm_medium")) {
        setMedium(sessionStorage.getItem("utm_medium"));
      }
      if (sessionStorage.getItem("utm_content")) {
        setContent(sessionStorage.getItem("utm_content"));
      }
      if (sessionStorage.getItem("utm_term")) {
        setTerm(sessionStorage.getItem("utm_term"));
      }
    }, []);

    return !!storeLink ? (
      <Link
        to={storeLink}
        className={classNames("btn-wtb-acc button ", className)}
        target="_blank"
        rel="noreferrer"
      >
        {iconName && (
          <Icon name={iconName} className={classNames("button-icon", color)} alt={iconName}></Icon>
        )}
        {label}
      </Link>
    ) : (
      <button
        className={className}
        onClick={reevooTrack}
        data-product-sku={sku}
        data-asset-id={assetId}
        data-csi_utm_campaign={campaign}
        data-csi_utm_source={source}
        data-csi_utm_medium={medium}
        data-csi_utm_term={term}
        data-csi_utm_content={content}
        ref={ref}
      >
        {iconName && (
          <Icon name={iconName} className={classNames("button-icon", color)} alt={iconName}></Icon>
        )}
        {label}
      </button>
    );
  }
);

export default ButtonWTB;
